import { InputAdornment } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export const MuiDatePicker = (props: any) => {
    const {
        id,
        name,
        label,
        value,
        onChange,
        fullWidth,
        disablePast,
        disableFuture,
        error,
        placeholder,
        minDate,
        disabled,
        maxDate
    } = props;

    const convertToDefEventPara = (name: any, value: any) => ({
        target: {
            name,
            value,
        },
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
                sx={{

                    "&.MuiStack-root": {
                        overflow: "inherit",
                        width: "100%",
                    },
                    borderColor: '#DEE4EB',
                }}
                components={["DatePicker", "DatePicker"]}
            >
                <DatePicker
                    value={value && dayjs(value, "DD/MM/YYYY")}
                    format="DD/MM/YYYY"
                    disablePast={disablePast}
                    disableFuture={disableFuture}
                 
                    disabled ={disabled}
                    sx={{
                        "&.MuiFormControl-root": {
                            minWidth: "100%",
                        },
                    }}
                    minDate = {dayjs().add(2, 'day')}
                    maxDate={dayjs().add(30, 'day')}
         
                    slotProps={{
                        textField: {
                            id: id,
                            size: "small",
                            fullWidth,
                            error: !!error,
                            helperText: error,
                            
                            onKeyDown:(e:any)=>{
                              
                               
                            },
                            inputProps: {
                              
                            readOnly:true,
                            },
                            InputProps: {
                                placeholder: placeholder,

                                // onKeyDown:(e:any)=>{
                                //     e.preventDefault()
                                // }
                            },
                            sx: {
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#DEE4EB',
                                    }
                                }
                            }
                        },
                    }}
                    onChange={(date) => onChange(convertToDefEventPara(name, date))}

                />
            </DemoContainer>
        </LocalizationProvider>

    );
};
